const TRANSFER_ACTIONS = {
  SET_CUSTOMER_INFO: "SET_CUSTOMER_INFO",
  SET_INTERNAL_TRANSFER_OTP: "SET_INTERNAL_TRANSFER_OTP"
};
export default TRANSFER_ACTIONS;
